const formatPrice = (price: number) => `€ ${(price ?? 0).toFixed(2)}`;

export {
    formatPrice
}
